import * as constants from './constants'

export const getAllSurveysByCountry = () => ({
    type: constants.GET_ALL_SURVEYS_BY_COUNTRY,
})

export const setAllSurveysByCountry = data => ({
    type: constants.SET_ALL_SURVEYS_BY_COUNTRY,
    data,
})

export const sendSurveyAnswer = (rating, ratingText) => ({
    type: constants.SEND_SURVEY_ANSWER,
    rating,
    ratingText,
})

export const setAnswerSendingResult = data => ({
    type: constants.SET_ANSWERS_SENDING_RESULT,
    data,
})

export const getAllSurveysByCountryAdmin = () => ({
    type: constants.GET_ALL_SURVEY_BY_COUNTRY_ADMIN,
})

export const npsAdminLogin = (username, password) => ({
    type: constants.NPS_ADMIN_LOGIN,
    username,
    password,
})

export const setNpsAdminAuthenticated = authenticated => ({
    type: constants.SET_NPS_ADMIN_AUTHENTICATED,
    authenticated,
})

export const setNpsAdminAuthError = error => ({
    type: constants.SET_NPS_ADMIN_AUTH_ERROR,
    error,
})

export const setAllSurveysByCountryAdmin = data => ({
    type: constants.SET_ALL_SURVEY_BY_COUNTRY_ADMIN,
    data,
})

export const setActualSurveyByCountryAdmin = data => ({
    type: constants.SET_ACTUAL_SURVEY_BY_COUNTRY_ADMIN,
    data,
})

export const getSurveyResultsById = id => ({
    type: constants.GET_SURVEY_RESULTS_BY_ID,
    id,
})

export const setSurveyResultsById = data => ({
    type: constants.SET_SURVEY_RESULTS_BY_ID,
    data,
})

export const getSurveyTextAnswersById = (id, rating, page) => ({
    type: constants.GET_SURVEY_TEXT_ANSWER_BY_ID,
    id,
    rating,
    page,
})

export const setSurveyTextAnswersById = data => ({
    type: constants.SET_SURVEY_TEXT_ANSWER_BY_ID,
    data,
})

export const setChartData = data => ({
    type: constants.SET_CHART_DATA,
    data,
})

export const addNewSurvey = data => ({
    type: constants.ADD_NEW_SURVEY_BY_COUNTRY,
    data,
})

export const setAddSurveySendingResult = result => ({
    type: constants.ADD_NEW_SURVEY_BY_COUNTRY_RESULT,
    result,
})

export const setAddSurveySendingError = error => ({
    type: constants.ADD_NEW_SURVEY_BY_COUNTRY_ERROR,
    error,
})

export const clearAddSurveySendingResult = () => ({
    type: constants.CLEAR_ADD_NEW_SURVEY_BY_COUNTRY_RESULT,
})

export const clearAddSurveySendingError = () => ({
    type: constants.CLEAR_ADD_NEW_SURVEY_BY_COUNTRY_ERROR,
})

export const cancelSurvey = id => ({
    type: constants.CANCEL_SURVEY,
    id,
})

export const updateExistingSurvey = survey => ({
    type: constants.UPDATE_EXISTING_SURVEY,
    survey,
})

export const clearAnswerSentIndicator = () => ({
    type: constants.CLEAR_ANSWER_SENT_INDICATOR,
})

export const getSurveyCSV = id => ({
    type: constants.GET_SURVEY_CSV,
    id,
})

export const setCSVData = data => ({
    type: constants.SET_CSV_DATA,
    data,
})

export const clearSurveyResultsValue = () => ({
    type: constants.CLEAR_SURVEY_RESULTS_VALUE,
})
